import styled from "styled-components"

export const Wrapper = styled.div`
  flex: 0.5;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 400px;
`

export const TextWrapper = styled.div`
  margin: 0 60px;
`
